import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ allowedRoles = [], children }) => {
    const { getUserInfo } = useAuth();
    const user = getUserInfo();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (
        allowedRoles.length > 0 &&
        !allowedRoles.some(role =>
            user.roles?.some(ur => ur.roleName === role)
        )
    ) {
        return <Navigate to="/unauthorized" replace />;
    }

    return children;
};
export default ProtectedRoute;